const dramas = [
  {
    title: '《长安十二时辰之风起云涌》',
    tag: '古装悬疑',
    rating: '9.2',
    desc: '盛世长安暗流涌动，一场跨越十二时辰的生死追击。全新篇章，原班人马回归。',
    img: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20historical%20drama%20poster%20style%2C%20Tang%20dynasty%20warrior%20silhouette%2C%20warm%20golden%20and%20red%20tones%2C%20epic%20cinematic%20portrait%20composition%2C%20misty%20ancient%20palace%20background%2C%20dramatic%20lighting%2C%20premium%20drama%20poster%20aesthetic&width=600&height=800&seq=card-drama-01&orientation=portrait',
    hot: true,
  },
  {
    title: '《锦瑟年华》',
    tag: '年代情感',
    rating: '8.7',
    desc: '跨越三十年的爱恨纠葛，几代人的命运沉浮，温暖治愈的年代故事。',
    img: 'https://readdy.ai/api/search-image?query=Retro%20Chinese%20romantic%20drama%20poster%2C%20vintage%201980s%20couple%20silhouette%20in%20warm%20sunset%20light%2C%20nostalgic%20sepia%20and%20rose%20tones%2C%20emotional%20portrait%20composition%2C%20soft%20dreamy%20atmosphere%2C%20period%20drama%20aesthetic&width=600&height=800&seq=card-drama-02&orientation=portrait',
    hot: false,
  },
  {
    title: '《暗夜追光》',
    tag: '犯罪悬疑',
    rating: '9.0',
    desc: '高智商罪案与硬核刑侦的巅峰对决，每一集都让你欲罢不能。',
    img: 'https://readdy.ai/api/search-image?query=Crime%20thriller%20drama%20poster%20style%2C%20noir%20detective%20silhouette%20in%20urban%20night%20scene%2C%20dark%20blue%20and%20warm%20accent%20lighting%2C%20suspenseful%20cinematic%20portrait%2C%20modern%20city%20neon%20glow%20background%2C%20mysterious%20atmosphere&width=600&height=800&seq=card-drama-03&orientation=portrait',
    hot: true,
  },
  {
    title: '《山海情缘》',
    tag: '现实题材',
    rating: '9.4',
    desc: '山海协作扶贫路上的感人故事，普通人的不平凡人生，温情励志。',
    img: 'https://readdy.ai/api/search-image?query=Rural%20Chinese%20inspirational%20drama%20poster%2C%20mountain%20and%20sea%20landscape%20with%20warm%20sunlight%2C%20heartfelt%20portrait%20composition%2C%20natural%20golden%20hour%20lighting%2C%20hopeful%20atmosphere%2C%20realistic%20rural%20aesthetic&width=600&height=800&seq=card-drama-04&orientation=portrait',
    hot: false,
  },
  {
    title: '《逆流时光》',
    tag: '奇幻爱情',
    rating: '8.5',
    desc: '一场意外让她回到十年前，重新选择人生的奇幻浪漫之旅。甜度满分。',
    img: 'https://readdy.ai/api/search-image?query=Fantasy%20romance%20Chinese%20drama%20poster%2C%20time%20travel%20theme%20with%20dreamy%20soft%20lighting%2C%20romantic%20couple%20silhouette%2C%20magical%20particle%20effects%2C%20warm%20pink%20and%20golden%20tones%2C%20ethereal%20atmosphere%2C%20youthful%20aesthetic&width=600&height=800&seq=card-drama-05&orientation=portrait',
    hot: false,
  },
  {
    title: '《风起洛阳之盛世华章》',
    tag: '古装传奇',
    rating: '8.8',
    desc: '神都洛阳再现辉煌，工部奇案牵出惊天密谋。顶配制作，视觉盛宴。',
    img: 'https://readdy.ai/api/search-image?query=Luxurious%20ancient%20Chinese%20palace%20drama%20poster%2C%20Tang%20dynasty%20Luoyang%20city%20golden%20rooftop%20scene%2C%20rich%20imperial%20yellow%20and%20red%20tones%2C%20epic%20historical%20portrait%20composition%2C%20grand%20scale%2C%20ornate%20details%2C%20premium%20aesthetic&width=600&height=800&seq=card-drama-06&orientation=portrait',
    hot: true,
  },
  {
    title: '《星河万里》',
    tag: '都市职场',
    rating: '8.3',
    desc: '航天科技领域的职场群像，梦想与现实的碰撞。燃向励志，新鲜感十足。',
    img: 'https://readdy.ai/api/search-image?query=Modern%20workplace%20Chinese%20drama%20poster%2C%20aerospace%20technology%20theme%20with%20starry%20night%20sky%2C%20professional%20young%20silhouette%2C%20futuristic%20clean%20aesthetic%2C%20deep%20blue%20and%20silver%20tones%2C%20inspirational%20composition%2C%20sleek%20design&width=600&height=800&seq=card-drama-07&orientation=portrait',
    hot: false,
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-18 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-8">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-2">热播剧集</h2>
          <p className="text-sm text-foreground-500">精选高分好剧，每一部都是诚意之作</p>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
          {dramas.slice(0, 7).map((drama) => (
            <a
              key={drama.title}
              href="#carousel"
              className="group block bg-background-50 rounded-xl overflow-hidden border border-background-200/60 hover:border-primary-200 transition-all cursor-pointer"
            >
              <div className="relative aspect-[3/4] overflow-hidden bg-background-200">
                <img
                  src={drama.img}
                  alt={drama.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-2 left-2 flex items-center gap-1.5">
                  <span className="px-2 py-0.5 rounded-md text-xs font-medium bg-primary-500/90 text-background-50 whitespace-nowrap">
                    {drama.tag}
                  </span>
                  {drama.hot && (
                    <span className="px-2 py-0.5 rounded-md text-xs font-medium bg-accent-500/90 text-background-50 whitespace-nowrap">
                      热播
                    </span>
                  )}
                </div>
                <div className="absolute bottom-2 right-2 px-2 py-0.5 rounded-md text-xs font-bold bg-background-950/70 text-accent-400 whitespace-nowrap">
                  {drama.rating}
                </div>
              </div>
              <div className="p-3 md:p-4">
                <h3 className="font-heading text-sm md:text-base font-bold text-foreground-950 mb-1 group-hover:text-primary-600 transition-colors line-clamp-1">
                  {drama.title}
                </h3>
                <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2">
                  {drama.desc}
                </p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}